// components/ReleasePreview.jsx
import React from 'react';
import { CheckCircleIcon, BugAntIcon, WrenchIcon } from '@heroicons/react/24/outline';

const ReleasePreview = ({ releaseData }) => {
  const getIconForSection = (title) => {
    switch (title) {
      case 'Features':
        return <CheckCircleIcon className="h-6 w-6 text-green-500" />;
      case 'Bug Fixes':
        return <BugAntIcon className="h-6 w-6 text-red-500" />;
      case 'Maintenance':
        return <WrenchIcon className="h-6 w-6 text-blue-500" />;
      default:
        return null;
    }
  };

  const renderDescription = (description) => {
    return description?.split('\n').map((text, index) => (
      <p key={index} className="mb-4 text-gray-700">
        {text}
      </p>
    ));
  };

  return (
    <div className="w-full p-4 sm:p-8"> {/* Adjusted padding for mobile with p-4 */}
      <h2 className="text-3xl font-bold mb-4 text-[#8A79EC]">{releaseData.version || 'Version'}</h2>
      <div className="mb-4">
        <h3 className="text-xl font-semibold">{releaseData.releaseTitle || 'Release Title'}</h3>
        <p className="text-gray-500">
          {releaseData.date
            ? new Date(releaseData.date).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })
            : 'Date'}
        </p>
      </div>
      <div className="text-gray-700 mb-8">{renderDescription(releaseData.description)}</div>

      {releaseData.sections.map((section, index) => (
        <div key={index} className="mb-6">
          <div className="flex items-center mb-2">
            {getIconForSection(section.title)}
            <h4 className="ml-2 font-medium text-gray-800">{section.title}</h4>
          </div>
          <ul className="list-disc ml-8 mt-2">
            {section.items.map((item, idx) =>
              item.text ? (
                <li key={idx} className="text-gray-600 pb-1">
                  {item.text}
                </li>
              ) : (
                <li key={idx} className="my-8 flex justify-center">
                  <img
                    src={item.image}
                    alt="Release"
                    className="rounded-md w-full sm:w-full md:w-2/3 lg:w-2/3 border border-gray-300"
                  />
                </li>
              )
            )}
          </ul>
        </div>
      ))}
    </div>
  );
};

export default ReleasePreview;